<template>
  <svg
    :class="{
      'text-www-color-accent': true,
    }"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5_1021)">
      <path
        d="M3.74792 2.99854H14.2421C15.0695 2.99854 15.7412 3.67029 15.7412 4.4977V14.9919C15.7412 15.8193 15.0695 16.491 14.2421 16.491H3.74792C2.9205 16.491 2.24875 15.8193 2.24875 14.9919V4.4977C2.24875 3.67029 2.9205 2.99854 3.74792 2.99854V2.99854"
        stroke="currentColor"
        stroke-width="1.42421"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9933 1.49902V4.49736M5.99667 1.49902V4.49736M2.24875 7.49569H15.7412"
        stroke="currentColor"
        stroke-width="1.42421"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5_1021">
        <rect
          width="17.99"
          height="17.99"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
